import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import "./JDS_Styles/main.scss";
import { Footer, TokenProvider } from "@jds/core";
import SideNav from "./Components/SideNav";
import Nav from "./Routes/Nav";
import "./Styles/app.css";
import FooterComponent from "./Components/FooterComponent";
import HeaderComponent from "./Components/HeaderComponent";
import { Provider, useDispatch, useSelector } from "react-redux";

import { getUserDashboardTheme } from "./store/actions/CommonAction";
import { applyPortalThemeToDom } from "./utils/applyPortalTheme";
function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const businessId = useSelector((state) => state.common.business_id);
  const secureId = useSelector((state) => state.common.secure_id);
  const tenantId = useSelector((state) => state.common.tenant_id);
  const portalTheme = useSelector((state) => state.common.portal_theme);

  useEffect(() => {
    if (tenantId && businessId) {
      dispatch(getUserDashboardTheme());
    }
  }, [dispatch, tenantId, businessId, secureId]);

  useEffect(() => {
    applyPortalThemeToDom(portalTheme);
    if (portalTheme?.portalTitle) {
      document.title = portalTheme.portalTitle;
    }
  }, [portalTheme]);

  const hideSideNavRoutes = [
    "/app-documents",
    "/requests/",
    "/createRequest",
    "/integrationGrievanceRequests",
    "/integrationCreateRequest",
    "/integrationGrievanceRequests/:grievanceId",
  ];
  const hideSideNav = hideSideNavRoutes.some((p) =>
    location.pathname.startsWith(p),
  );

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const shouldLock = !hideSideNav && mobileNavOpen;
    document.body.style.overflow = shouldLock ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [hideSideNav, mobileNavOpen]);

  return (
    <TokenProvider theme="JioBase" mode="light">
      <HeaderComponent
        showMobileNavToggle={!hideSideNav}
        mobileNavOpen={mobileNavOpen}
        onMobileNavToggle={() => setMobileNavOpen((open) => !open)}
      />
      <div className={!hideSideNav ? "app-layout" : ""}>
        {!hideSideNav && (
          <>
            {mobileNavOpen ? (
              <div
                className="mobile-nav-backdrop"
                onClick={() => setMobileNavOpen(false)}
                aria-hidden="true"
              />
            ) : null}
            <SideNav
              mobileNavOpen={mobileNavOpen}
              onMobileNavClose={() => setMobileNavOpen(false)}
            />
          </>
        )}
        <Nav />
      </div>
      {!hideSideNav && <FooterComponent />}
    </TokenProvider>
  );
}

export default App;
